import { ReactComponent as CalendarIcon } from "assets/icons/calendar-icon.svg";
import React from "react";
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { MulitDatePickerProps } from "./MultiDatePicker.props";
import moment from "jalali-moment";
import "./style.scss";
import { persianToEnglishNumber } from "utils/helpers";

const MultiDatePicker = React.memo<MulitDatePickerProps>(
    ({
        isMonthPicker,
        containerClassName,
        datePickerClassName,
        calendarPosition,
        inputClassName,
        isPersian,
        setMultipleDate,
        withoutClass,
        date,
        label,
        setDate,
        title = "",
        placeholder = "",
        minDate,
        maxDate,
        faDate,
        ...props
    }) => {
        const isGregorianDate = (date: string) => {
            const gregorianDateRegex =
                /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
            return gregorianDateRegex.test(date);
        };
        return (
            <div
                className={
                    withoutClass
                        ? ""
                        : "d-flex flex-column justify-content-between"
                }
                style={{ minWidth: "180px", paddingLeft: "20px" }}
            >
                {!!label && <span>{label}</span>}
                <DatePicker
                    containerClassName={containerClassName || ""}
                    className={`datepicker ${datePickerClassName || ""}`}
                    calendarPosition={calendarPosition}
                    inputClass={`rmdp-input ${inputClassName || ""}`}
                    editable={false}
                    onOpenPickNewDate={false}
                    onlyMonthPicker={isMonthPicker || false}
                    render={(value: any, openCalendar: any) => {
                        const formatToDayMonth = (date: any) => {
                            if (!isGregorianDate(date)) {
                                try {
                                    const englishDate =
                                        persianToEnglishNumber(date);
                                    const momentDate = moment(
                                        englishDate,
                                        "jYYYY/jMM/jDD"
                                    ).locale("fa");

                                    if (!momentDate.isValid()) {
                                        return "تاریخ نامعتبر";
                                    }

                                    return `${momentDate.format("jD jMMMM")}`;
                                } catch (error) {
                                    return "خطا در فرمت تاریخ";
                                }
                            }
                        };

                        const changeToPersianStr = (value: any) => {
                            const formattedDates = value?.map((date: string) =>
                                formatToDayMonth(date)
                            );
                            return formattedDates.join(" تا ");
                        };

                        return (
                            <div
                                className={`kitchen-datepicker-wrap ${
                                    inputClassName || ""
                                }`}
                                onClick={openCalendar}
                                data-testid="DatePicker"
                            >
                                {!label && (
                                    <CalendarIcon className="calendar-icon" />
                                )}
                                {faDate ? (
                                    <div className="persian-period-str">
                                        {changeToPersianStr(value)}
                                    </div>
                                ) : (
                                    <>
                                        {value[1] && setMultipleDate ? (
                                            <p
                                                className="selected-date"
                                                data-testid="DatePicker__paragraph"
                                            >
                                                {`${value[0]} - تا - ${value[1]}`}
                                            </p>
                                        ) : (
                                            <p
                                                className="selected-date"
                                                data-testid="DatePicker__paragraph"
                                            >
                                                {value || title}
                                            </p>
                                        )}
                                    </>
                                )}
                            </div>
                        );
                    }}
                    format="YYYY/MM/DD"
                    calendar={isPersian ? persian : gregorian}
                    locale={isPersian ? persian_fa : gregorian_en}
                    value={date}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={
                        setMultipleDate
                            ? (date: DateObject[]) => setMultipleDate(date)
                            : (date: DateObject) => setDate(date)
                    }
                    {...props}
                />
            </div>
        );
    }
);

export default MultiDatePicker;
